var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"watermark-overlay",attrs:{"aria-hidden":"true"}},_vm._l((_vm.items),function(item){return _c('span',{key:item.key,staticClass:"watermark-item",style:(item.style)},[_vm._v(" "+_vm._s(_vm.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }